import React from 'react';
import { Container, Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FiMapPin, FiPhone, FiMail, FiSend } from 'react-icons/fi';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import styles from './bodywon.module.css';

const BodywonFooter = () => {
  return (
    <footer className={styles.footer}>
      <Container>
        <Row className="gy-5">

          <Col lg={3} md={6}>
            <h5 className={styles.footerTitle}>STORE INFORMATION</h5>
            <ul className={styles.infoList}>
              <li><FiMapPin /> <span>Blossom - Lingerie Store<br />United States</span></li>
              <li><FiPhone /> <span>000-000-0000</span></li>
              <li><FiMail /> <span>sales@yourcompany.com</span></li>
            </ul>
          </Col>

          <Col lg={3} md={6}>
            <h5 className={styles.footerTitle}>INFORMATION</h5>
            <ul className={styles.linkList}>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Delivery Information</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms &amp; Conditions</a></li>
              <li><a href="#">Site Map</a></li>
            </ul>
          </Col>

          <Col lg={2} md={6}>
            <h5 className={styles.footerTitle}>MY ACCOUNT</h5>
            <ul className={styles.linkList}>
              <li><a href="#">My Account</a></li>
              <li><a href="#">Order History</a></li>
              <li><a href="#">Wish List</a></li>
              <li><a href="#">Newsletter</a></li>
              <li><a href="#">Returns</a></li>
            </ul>
          </Col>

          <Col lg={4} md={6}>
            <h5 className={styles.footerTitle}>NEWSLETTER</h5>
            <p>Alteration in some form injected humour words which.</p>
            <InputGroup className={styles.newsletterForm}>
              <Form.Control placeholder="Enter Your Email Address" />
              <Button variant="dark" className={styles.newsletterButton}><FiSend /></Button>
            </InputGroup>
            <div className={styles.socialIconsFooter}>
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaXTwitter /></a>
              <a href="#"><FaInstagram /></a>
            </div>
          </Col>

        </Row>
      </Container>
      <div className={styles.copyrightBar}>
        <Container>
          <p>Powered By AI Comm</p>
        </Container>
      </div>
    </footer>
  );
};

export default BodywonFooter;
